import type { UseFormSetValue } from 'react-hook-form';
import { Card, CardContent } from '@/components/ui/card';
import { ShieldAlert, Flame, Motorbike, Bike, Zap, Trees, Boxes } from 'lucide-react';
import type { DeclarationSinistreValues } from '@/hooks/api/use-accidents';

const getProductIcon = (codeProduit?: string) => {
    if (!codeProduit) return Motorbike;
    const code = codeProduit.toUpperCase();
    if (code.includes('VAE')) return Bike;
    if (code.includes('MAE') && code.includes('NVEI')) return Zap;
    if (code.includes('QUAD') || code.includes('VERTE') || code.includes('QUA') || code.includes('MVE')) return Trees;
    if (code.includes('LIV') || code.includes('LIVRAISON')) return Boxes;
    return Motorbike;
};

interface SelectionSinistreProps {
    setValue: UseFormSetValue<DeclarationSinistreValues>;
    codeProduit?: string;
}

const SelectionSinistre = (props: SelectionSinistreProps) => {
    const { setValue, codeProduit } = props;

    const ProductIcon = getProductIcon(codeProduit);

    const options = [
        {
            type: 'accident',
            icon: ProductIcon,
            title: 'Accident',
            description: 'Collision, chute, choc avec un véhicule, piéton ou animal',
        },
        {
            type: 'vol',
            icon: ShieldAlert,
            title: 'Vol - Tentative de Vol',
            description: 'Disparition ou tentative de vol de votre véhicule',
        },
        {
            type: 'autres',
            icon: Flame,
            title: 'Autres',
            description: 'Incendie, vandalisme, événement climatique...',
        },
    ];

    return (
        <div className="mt-6">
            <p className="text-sm text-muted-foreground mb-6">Sélectionnez le type de sinistre à déclarer :</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {options.map((opt) => {
                    const Icon = opt.icon;
                    return (
                        <Card
                            key={opt.type}
                            role="button"
                            tabIndex={0}
                            aria-label={`Déclarer un sinistre ${opt.title}`}
                            className="cursor-pointer transition-all duration-200 hover:shadow-lg hover:border-primary/50 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
                            onClick={() => setValue('type_sinistre', opt.type)}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setValue('type_sinistre', opt.type); } }}
                        >
                            <CardContent className="flex flex-col items-center text-center p-6 sm:p-8">
                                <div className="flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10 mb-6">
                                    <Icon className="w-8 h-8 text-destructive" />
                                </div>
                                <p className="font-semibold text-sm mb-1">Déclarer un sinistre</p>
                                <p className="font-bold text-base">{opt.title}</p>
                                <p className="text-xs text-muted-foreground mt-2">{opt.description}</p>
                            </CardContent>
                        </Card>
                    );
                })}
            </div>
        </div>
    );
};

export default SelectionSinistre;
